module.exports = __webpack_public_path__ + "static/media/testimonal15.a9e9b4d3.webp";